// JSON-LD for the `rank_boosters` surface — boosters leaderboard rank
// share for a specific user. Schema-wise it's a Person (the ranked user)
// with the rank expressed as `award`. Mirrors `rank.ts` but uses the
// boosters ranks.

import type { ShareSurface } from '@/lib/share/events';

import { resolveCanonicalOrigin } from '../origin';
import { organizationId, websiteId } from './site';
import type { JsonLdBuilderContext, JsonLdPayload } from './types';

export function buildRankBoostersJsonLd(
  surface: Extract<ShareSurface, { kind: 'rank_boosters' }>,
  ctx: JsonLdBuilderContext,
): JsonLdPayload {
  const personName = ctx.name ?? 'Morfi booster';
  const personUrl = `${resolveCanonicalOrigin()}/portfolio/${surface.userId}`;
  const awards: string[] = [];
  if (surface.amountRank > 0) awards.push(`Rank #${surface.amountRank} by amount boosted`);
  if (surface.boostsRank > 0) awards.push(`Rank #${surface.boostsRank} by number of boosts`);
  if (surface.marketsBoostedRank > 0)
    awards.push(`Rank #${surface.marketsBoostedRank} by markets boosted`);
  return [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${ctx.pageUrl}#webpage`,
      url: ctx.pageUrl,
      name: ctx.description ?? `${personName} on the Morfi boosters leaderboard`,
      primaryImageOfPage: { '@type': 'ImageObject', url: ctx.ogImageUrl },
      isPartOf: { '@id': websiteId() },
      publisher: { '@id': organizationId() },
      mainEntity: {
        '@type': 'Person',
        '@id': `${personUrl}#person`,
        name: personName,
        url: personUrl,
        image: ctx.ogImageUrl,
        ...(awards.length > 0 ? { award: awards } : {}),
      },
    },
  ];
}
